import { Map } from 'immutable';
import { AnyAction } from 'redux';

import Location from 'entities/location/model';

import { ADD_MULTIPLE, REMOVE } from './constants';

export type LocationState = Map<string, Location>;

const initialState = Map<string, Location>();

export default (state = initialState, action: AnyAction): LocationState => {
  switch (action.type) {
    case ADD_MULTIPLE:
      return state.merge(action.locations);

    case REMOVE:
      return state.delete(action.id);

    default:
      return state;
  }
};
